/**
 * 端口句柄（handle）的**名字比较** —— 一个纯函数，零依赖。
 *
 * ## 为什么单独成文件（原先在 `graph/connectionRules.ts` 里）
 *
 * 它是**数据层**的东西（端口 id 的等价判定），却被 `node/validate.ts` 用着 ——
 * 而 `node/` 是纯函数层，不该 import 适配层（`graph/`）。
 * 放在这里之后依赖方向就正了：
 *
 * ```text
 *   types  ←  node  ←  graph  ←  playground
 *              ↑
 *              └─ connectionRules / validate 都从这里拿
 * ```
 *
 * ⚠️ **不用 `===` 比较**：`null` / `undefined` / `''` 必须视为同一个。
 * Vue Flow 的 `connectionExists` 用的就是「都为空即相同」这种判定，
 * 改成严格相等会出现「一个输入挂了两条边」的漏网情况。
 */

/** 两个 handle 名是不是同一个（`null` / `undefined` / `''` 等价） */
export function sameHandle(a?: string | null, b?: string | null): boolean {
  return (a ?? '') === (b ?? '')
}
